import React from 'react'
import { Modal, Form, Col, Row, Button } from 'react-bootstrap'
import { createModal, ModalResolveType, useModalAction } from '@src/lib/modal-manager'
import { useForm } from '@src/lib/react-hook-form'
import z from 'zod'

interface CarInfo {
  engineNo: string;
  idotNo?: string;
}

interface EditCarInfoProps {
  itemDto: CarInfo;
}

export function EditCarInfoModalWrapper(props: EditCarInfoProps) {
  const { resolve, remove, hide } = useModalAction()
  const { itemDto } = props

  const { register, handleSubmit, formState: { errors } } = useForm<CarInfo>({
    reValidateMode: 'onSubmit',
    defaultValues: itemDto,
    rules: z.object({
      engineNo: z.string().nonempty({ message: '請輸入引擎號碼' }),
      idotNo: z.string().optional()
    })
  })

  const handleClose = () => {
    resolve(ModalResolveType.CLOSED)
    hide()
    remove()
  }

  const handleCancel = () => {
    resolve(ModalResolveType.CANCEL)
    hide()
    remove()
  }

  const handleOnSubmit = (formDto: CarInfo) => {
    resolve(ModalResolveType.OK, formDto)
    hide()
    remove()
  }

  return (
    <Modal size='lg' show onHide={handleClose} centered>
      <Form onSubmit={handleSubmit(handleOnSubmit)}>
        <Modal.Header closeButton>
          <Modal.Title>編輯車籍資料</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              引擎編號
            </Form.Label>
            <Col sm="10">
              <Form.Control {...register('engineNo')} />
            </Col>
            {errors.engineNo && <Form.Text className='text-danger'>{errors.engineNo.message}</Form.Text>}
          </Form.Group>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm="2">
              車身編號
            </Form.Label>
            <Col sm="10">
              <Form.Control {...register('idotNo')} />
            </Col>
            {errors.idotNo && <Form.Text className='text-danger'>{errors.idotNo.message}</Form.Text>}
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleCancel} variant='light'>
            取消
          </Button>
          <Button type='submit'>
            確認
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export const EditCarInfoModal = createModal(EditCarInfoModalWrapper)
